export const SectionType = [
    // 以下为能够创建多线的截面类型
    { key: '1', label: '热轧截面', item: [1, 3, 7] },
    { key: '2', label: '冷弯截面', item: [25, 26] },
    { key: '3', label: '焊接截面', item: [41, 43, 45] },
    // { key: '1', label: '热轧截面', item: [1, 2, 3, 4, 5, 6, 7, 8] },
    // { key: '2', label: '冷弯截面', item: [21, 22, 23, 24, 25, 26, 27, 28] },
    // { key: '3', label: '焊接截面', item: [41, 42, 43, 44, 45, 46, 47, 48] },
    // { key: '4', label: '组合截面', item: [61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74] },
]

export const SectionTypeItemT = {
    1: { key: '1', label: '热轧截面', item: [1, 3, 7] },
    2: { key: '2', label: '冷弯截面', item: [25, 26] },
    3: { key: '3', label: '焊接截面', item: [41, 43, 45] },
    // 1: { key: '1', label: '热轧截面', item: [1, 2, 3, 4, 5, 6, 7, 8] },
    // 2: { key: '2', label: '冷弯截面', item: [21, 22, 23, 24, 25, 26, 27, 28] },
    // 3: { key: '3', label: '焊接截面', item: [41, 42, 43, 44, 45, 46, 47, 48] },
    // 4: { key: '4', label: '组合截面', item: [61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74] },
}

export const SectionTypeItem = [
    // 热轧截面
    { key: '1', label: 'H型钢', image: require('@/commons/icons/section/HR-H/HR-H_3@3x.png'), thumbnail: require('@/commons/icons/section/HR-H/HR-H@3x.png'), },
    // { key: '2', label: 'T型钢', image: require('@/commons/icons/section/HR-T/HR-T_3@3x.png'), thumbnail: require('@/commons/icons/section/HR-T/HR-T@3x.png') },
    { key: '3', label: '工字钢', image: require('@/commons/icons/section/HR-I/HR-I_3@3x.png'), thumbnail: require('@/commons/icons/section/HR-I/HR-I@3x.png') },
    { key: '4', label: '槽钢', image: require('@/commons/icons/section/HR-C/HR-C_3@3x.png'), thumbnail: require('@/commons/icons/section/HR-C/HR-C@3x.png') },
    // { key: '5', label: '等边角钢', image: require('@/commons/icons/section/HR-L/HR-L_3@3x.png'), thumbnail: require('@/commons/icons/section/HR-L/HR-L@3x.png') },
    // { key: '6', label: '不等边角钢', image: require('@/commons/icons/section/HR-L1/HR-L1_3@3x.png'), thumbnail: require('@/commons/icons/section/HR-L1/HR-L1@3x.png') },
    { key: '7', label: '圆管', image: require('@/commons/icons/section/HR-CT/HR-CT_3@3x.png'), thumbnail: require('@/commons/icons/section/HR-CT/HR-CT@3x.png') },
    // { key: '8', label: '扁钢', image: require('@/commons/icons/section/HR-F/HR-F_3@3x.png'), thumbnail: require('@/commons/icons/section/HR-F/HR-F@3x.png') },
    // 冷弯截面
    // { key: '21', label: '卷边C型', image: require('@/commons/icons/section/CF-C/CF-C_3@3x.png'), thumbnail: require('@/commons/icons/section/CF-C/CF-C@3x.png') },
    { key: '22', label: 'C型', image: require('@/commons/icons/section/CF-C1/CF-C1_3@3x.png'), thumbnail: require('@/commons/icons/section/CF-C1/CF-C1@3x.png') },
    // { key: '23', label: '斜卷边Z型', image: require('@/commons/icons/section/CF-Z/CF-Z_3@3x.png'), thumbnail: require('@/commons/icons/section/CF-Z/CF-Z@3x.png') },
    // { key: '24', label: '直卷边Z型', image: require('@/commons/icons/section/CF-Z1/CF-Z1_3@3x.png'), thumbnail: require('@/commons/icons/section/CF-Z1/CF-Z1@3x.png') },
    { key: '25', label: '方钢管', image: require('@/commons/icons/section/CF-ST/CF-ST_3@3x.png'), thumbnail: require('@/commons/icons/section/CF-ST/CF-ST@3x.png') },
    { key: '26', label: '矩形管', image: require('@/commons/icons/section/CF-RT/CF-RT_3@3x.png'), thumbnail: require('@/commons/icons/section/CF-RT/CF-RT@3x.png') },
    // { key: '27', label: '等边L型', image: require('@/commons/icons/section/CF-L/CF-L_3@3x.png'), thumbnail: require('@/commons/icons/section/CF-L/CF-L@3x.png') },
    // { key: '28', label: '卷等边L', image: require('@/commons/icons/section/CF-L1/CF-L1_3@3x.png'), thumbnail: require('@/commons/icons/section/CF-L1/CF-L1@3x.png') },
    // 焊接截面
    { key: '41', label: '焊接H形', image: require('@/commons/icons/section/WS-H/WS-H_3@3X.png'), thumbnail: require('@/commons/icons/section/WS-H/WS-H@3x.png') },
    // { key: '42', label: '焊接T形', image: require('@/commons/icons/section/WS-T/WS-T_3@3x.png'), thumbnail: require('@/commons/icons/section/WS-T/WS-T@3x.png') },
    { key: '43', label: '箱形', image: require('@/commons/icons/section/WS-RT/WS-RT_3@3x.png'), thumbnail: require('@/commons/icons/section/WS-RT/WS-RT@3x.png') },
    // { key: '44', label: '外伸箱形', image: require('@/commons/icons/section/WS-RT1/WS-RT1_3@3x.png'), thumbnail: require('@/commons/icons/section/WS-RT1/WS-RT1@3x.png') },
    { key: '45', label: '圆管', image: require('@/commons/icons/section/WS-CT/WS-CT_3@3x.png'), thumbnail: require('@/commons/icons/section/WS-CT/WS-CT@3x.png') },
    // { key: '46', label: '十字形', image: require('@/commons/icons/section/WS-CR/WS-CR_3@3x.png'), thumbnail: require('@/commons/icons/section/WS-CR/WS-CR@3x.png') },
    // { key: '47', label: '日字形', image: require('@/commons/icons/section/WS-TC/WS-TC_3@3x.png'), thumbnail: require('@/commons/icons/section/WS-TC/WS-TC@3x.png') },
    { key: '48', label: '焊接C形', image: require('@/commons/icons/section/WS-C/WS-C_3@3x.png'), thumbnail: require('@/commons/icons/section/WS-C/WS-C@3x.png') },
    // 组合截面
    { key: '61', label: '工字形1', image: require('@/commons/icons/section/SC-H1/SC-H1_3@3x.png'), thumbnail: require('@/commons/icons/section/SC-H1/SC-H1@3x.png') },
    { key: '62', label: '工字形2', image: require('@/commons/icons/section/SC-H2/SC-H2_3@3x.png'), thumbnail: require('@/commons/icons/section/SC-H2/SC-H2@3x.png') },
    { key: '63', label: '工字形3', image: require('@/commons/icons/section/SC-H3/SC-H3_3@3x.png'), thumbnail: require('@/commons/icons/section/SC-H3/SC-H3@3x.png') },
    { key: '64', label: '工字形4', image: require('@/commons/icons/section/SC-H4/SC-H4_3@3x.png'), thumbnail: require('@/commons/icons/section/SC-H4/SC-H4@3x.png') },
    { key: '65', label: '工字形5', image: require('@/commons/icons/section/SC-H5/SC-H5_3@3x.png'), thumbnail: require('@/commons/icons/section/SC-H5/SC-H5@3x.png') },
    { key: '66', label: 'T形1', image: require('@/commons/icons/section/SC-T1/SC-T1_3@3x.png'), thumbnail: require('@/commons/icons/section/SC-T1/SC-T1@3x.png') },
    { key: '67', label: 'T形2', image: require('@/commons/icons/section/SC-T2/SC-T2_3@3x.png'), thumbnail: require('@/commons/icons/section/SC-T2/SC-T2@3x.png') },
    { key: '68', label: 'T形3', image: require('@/commons/icons/section/SC-T3/SC-T3_3@3x.png'), thumbnail: require('@/commons/icons/section/SC-T3/SC-T3@3x.png') },
    { key: '69', label: 'T形4', image: require('@/commons/icons/section/SC-T4/SC-T4_3@3x.png'), thumbnail: require('@/commons/icons/section/SC-T4/SC-T4@3x.png') },
    { key: '70', label: 'T形5', image: require('@/commons/icons/section/SC-T5/SC-T5_3@3x.png'), thumbnail: require('@/commons/icons/section/SC-T5/SC-T5@3x.png') },
    { key: '71', label: '箱形1', image: require('@/commons/icons/section/SC-BL/SC-BL_3@3x.png'), thumbnail: require('@/commons/icons/section/SC-BL/SC-BL@3x.png') },
    { key: '72', label: '箱形2', image: require('@/commons/icons/section/SC-BC/SC-BC_3@3x.png'), thumbnail: require('@/commons/icons/section/SC-BC/SC-BC@3x.png') },
    { key: '73', label: '十字形1', image: require('@/commons/icons/section/SC-CL/SC-CL_3@3x.png'), thumbnail: require('@/commons/icons/section/SC-CL/SC-CL@3x.png') },
    { key: '74', label: '十字形2', image: require('@/commons/icons/section/SC-CT/SC-CT_3@3x.png'), thumbnail: require('@/commons/icons/section/SC-CT/SC-CT@3x.png') },
]

export function getSectionInfo(key: string) {
    return SectionType.find(item => item.key === key) || null
}

export function getSectionTypeItemInfo(key: string) {
    return SectionTypeItem.find(item => item.key === key) || null
}

export function getSectionTypeItemList(key: string) {
    let res = [];
    switch (key.toString()) {
        case '1':
            res = SectionTypeItem.filter(item => Number(item.key) > 0 && Number(item.key) < 10);
            break;
        case '2':
            res = SectionTypeItem.filter(item => Number(item.key) > 20 && Number(item.key) < 30);
            break;
        case '3':
            res = SectionTypeItem.filter(item => Number(item.key) > 40 && Number(item.key) < 50);
            break;
        case '4':
            res = SectionTypeItem.filter(item => Number(item.key) > 60 && Number(item.key) < 80);
            break;
    }
    return res;
}

export function getSectionTypeForPolygon(key: string) {
    if (['1', '3', '41'].includes(key)) {
        return 'H型钢';
    }
    if (['7', '45'].includes(key)) {
        return '圆管';
    }
    if (['25', '26', '43'].includes(key)) {
        return '箱形';
    }
    if (['4', '22', '48'].includes(key)) {
        return '槽钢';
    }
    return '';
}